import styled from 'styled-components';

export const CopyButton = styled.img`
  width: 2rem;
  height: 2rem;
  cursor: pointer;
`;

export const StyledInvitePopup = styled.div`
  background: ${({ theme }) => theme.background};
  min-width: 30vw;
  max-width: 60vw;
  padding-top: 1.5rem;
`;

export const StyledInvitePopupContent = styled.div`
  padding: 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StyledInviteInputControls = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: row;
  gap: 1rem;
`;

export const CopiedLabel = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.mintGreen};
  font-size: 1rem;
  min-height: 1.25rem;
`;

export const StyledInviteButtonWrapper = styled.div`
  width: 6rem;
`;
